// extracted by mini-css-extract-plugin
module.exports = {"dock":"Dock_dock__9lbeU","button":"Dock_button__3Q7V7","buttonActive":"Dock_buttonActive__1MQUp","divider":"Dock_divider__2uvVg","history":"Dock_history__euwNn"};